import { createContext, useContext, useState, useCallback, type ReactNode } from 'react'

interface HeaderContextValue {
  headerSlot: ReactNode | null
  setHeaderSlot: (slot: ReactNode | null) => void
}

const HeaderContext = createContext<HeaderContextValue | null>(null)

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [headerSlot, setHeaderSlotState] = useState<ReactNode | null>(null)

  const setHeaderSlot = useCallback((slot: ReactNode | null) => {
    setHeaderSlotState(slot)
  }, [])

  return (
    <HeaderContext.Provider value={{ headerSlot, setHeaderSlot }}>
      {children}
    </HeaderContext.Provider>
  )
}

export function useHeader() {
  const ctx = useContext(HeaderContext)
  if (!ctx) throw new Error('useHeader deve ser usado dentro de HeaderProvider')
  return ctx
}
